import React , {useRef} from 'react';
import Header from '../Header';
import Footer from '../Footer';
import PaymentHeroSection from './PaymentHeroSection';
import PaymentBusinessAdSection from './PaymentBusinessAdSection';
import PaymentChooseUsSection from './PaymentChooseUsSection';
import PaymentFormSection from './paymentFormSection';
import usePageTitle from '../../hooks/usePageTitle';


const PaymentPage = () => {
    usePageTitle('page-title', 'paymentpage');
    const heroRef = useRef(null);
    const handleClick = () => {
        heroRef.current?.scrollIntoView({behavior: 'smooth'});
    };
    return (
        <>
            <Header />
            <PaymentHeroSection onScrollToForm={handleClick}/>
            <PaymentBusinessAdSection/>
            <PaymentFormSection ref={heroRef}/>
            <PaymentChooseUsSection/>
            <Footer />
        </>
    );
}

export default PaymentPage;